import { Container, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { navigate } from "gatsby";
import Header from "./blades/Header";
import { DataPortalService, Role } from "../api/DataPortalService";
import DatasetsViewer from "./blades/DatasetsViewer";
import ProjectDetails from "./blades/ProjectDetails";
import ProjectPermissions from "./blades/ProjectPermissions";
import ProjectMetadata from "./blades/ProjectTags";
import { Fragment } from "react";
import ProjectTags from "./blades/ProjectTags";
import ProjectBilling from "./blades/ProjectBilling";
import { Dataset, Project } from "../api/models";
import { Auth, DataStore } from "aws-amplify";
import { KeyValueInput } from "src/api/API";

const PortalProject: React.FC<any> = ({ theme, props }) => {
  const [project, setProject] = useState<Project>(null);
  const [datasets, setDatasets] = useState<Array<Dataset>>([]);
  const [billing, setBilling] = useState<Array<KeyValueInput>>([]);
  const [role, setRole] = useState<String>(Role.NONE);

  useEffect(() => {
    const subscription = DataStore.observe(Project).subscribe((msg) => {
      fetchData();
    });
    fetchData();
    return () => subscription.unsubscribe();
  }, []);

  async function fetchData() {
    const project = await DataPortalService.getProject(props.projectId);
    const datasets = await DataPortalService.getDatasets(project);
    const billing = await DataPortalService.getBilling(props.projectId);
    const role = await DataPortalService.getRole(props.projectId);
    const files = await DataPortalService.getDatasetFiles(
      props.projectId,
      "test"
    );
    setRole(role);
    setProject(project);
    setBilling(billing);
    setDatasets(datasets);
  }

  if (!project) return <Fragment></Fragment>;

  return (
    <Container fixed style={{ paddingBottom: "60px" }}>
      <Header />
      <Grid container spacing={4} alignItems="stretch">
        <Grid item xs={12}>
          <ProjectDetails project={project} role={role} billing={billing} />
        </Grid>
        <Grid item xs={12}>
          <DatasetsViewer project={project} datasets={datasets} />
        </Grid>

        <Grid item xs={12} lg={8}>
          <ProjectPermissions project={project} role={role} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ProjectTags project={project} role={role} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default PortalProject;
